import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  fetchGiftsFailure,
  fetchGiftsRequest,
  fetchGiftsSuccess,
} from "./GiftsSlice";

function* fetchGiftsSaga(action) {
  try {
    const { start = 0, limit = 5, search = "", startDate ="", endDate="" } = action.payload || {};

    const response = yield call(() =>
      axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/gift/giftList`,
        {
          params: {
            start,
            limit,
            search,
            startDate,
            endDate,
          },
        }
      )
    );

    const resData = response.data;

    if (resData.success) {
      const giftsList = resData.data?.gifts || [];
      const total = resData.data?.total || 0;

      yield put(
        fetchGiftsSuccess({
          gifts: giftsList,
          total,
          message: resData.message,
        })
      );
    } else {
      yield put(fetchGiftsFailure(resData.message));
    }
  } catch (error) {
    yield put(fetchGiftsFailure(error.message));
  }
}

export function* watchGiftSaga() {
  yield takeLatest(fetchGiftsRequest.type, fetchGiftsSaga);
}
